const downloadFiles = {
    table104: "104 1･3：法人税額の計算基礎.csv",
    table105: "105 4･5(1)：当期利益・納税充当金・通算税効果額等.csv",
    table106: "106 4･5(1)：通算税効果額の決済額等.csv",
    table108: "108 4･5(1)：連結法人税個別帰属額の決済額等.csv",
    table110: "110 4･5(1)：剰余金処分.csv",
    table111: "111 5(1)：資本金等の額.csv",
    table113: "113 5(2)：法人住民税・事業税等.csv",
    table114: "114 5(2)：その他の税金.csv",
    table201: "201 6(1)：預貯金・公社債の利子.csv",
    table202: "202 8(1)：支払利子配賦額の計算基礎.csv",
    tabledepreciation: "減価償却.csv"
};
export { downloadFiles };
